import axios from 'axios';
import { getApiEndpoint } from './utilities';

export default {
    initPayment(payload, cb) {
        axios.post(getApiEndpoint() + 'api/payment/' + payload.sessionId + '/initialise/')
            .then(response => {
                cb(response.data);
            });

    },
    initSpaPayment(payload, cb) {
        axios.post(getApiEndpoint() + 'api/payment/' + payload.sessionId + '/initialise-spa-payment/', payload.item)
            .then(response => {
                cb(response.data);
            });

    },
}

